import React, { useState } from 'react';
import UIKitInput from '../../shared/UIKITComponents/Input';
import UIKitButton from '../../shared/UIKITComponents/Button';

const ExampleForm: React.FC = () => {
  const [values, setValues] = useState({
    name: '',
    email: '',
    description: '',
  });

  const [errors, setErrors] = useState({
    name: false,
    email: false,
  });

  const handleChange =
    (field: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setValues({
        ...values,
        [field]: e.target.value,
      });
    };

  const validate = () => {
    const nextErrors = {
      name: values.name.trim() === '',
      email: !values.email.includes('@'),
    };
    setErrors(nextErrors);
    return !nextErrors.name && !nextErrors.email;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    validate();
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      {/* Name - medium */}
      <div style={{ marginBottom: 24 }}>
        <UIKitInput
          label="Name"
          placeholder="Enter your name"
          value={values.name}
          onChange={handleChange('name')}
          error={errors.name}
          helperText={errors.name && 'Name is required'}
        />
      </div>

      {/* Email - medium */}
      <div style={{ marginBottom: 24 }}>
        <UIKitInput
          label="Email"
          placeholder="Enter your email"
          value={values.email}
          onChange={handleChange('email')}
          error={errors.email}
          helperText={errors.email && 'Invalid email address'}
        />
      </div>

      {/* Small input */}
      <div style={{ marginBottom: 24 }}>
        <UIKitInput
          label="Reference code"
          size="small"
          placeholder="Optional"
          value={values.description}
          onChange={handleChange('description')}
        />
      </div>

      {/* Disabled */}
      <div style={{ marginBottom: 32 }}>
        <UIKitInput label="Read only" value="This field is disabled" disabled />
      </div>

      <UIKitButton text="Submit" type="submit" variant="flat" color="primary" />
    </form>
  );
};

export default ExampleForm;
